import { map } from 'rxjs/operators';
import { pipe } from 'rxjs';
import { invariant } from '@streem/toolbox';
/**
 * Sorts an observable array of WallItems in descending order based on the clientCreatedAt value.
 */
export function sortClientCreatedAt() {
    return pipe(map((items) => items.sort((a, b) => {
        if (!b.clientCreatedAt || !a.clientCreatedAt) {
            return -1;
        }
        invariant(a.clientCreatedAt.seconds, 'WallItem must define when it was created at in seconds');
        invariant(b.clientCreatedAt.seconds, 'WallItem must define when it was created at in seconds');
        return b.clientCreatedAt.seconds.sub(a.clientCreatedAt.seconds).toNumber();
    })));
}
//# sourceMappingURL=sort_client_created_at.js.map